import { render, staticRenderFns } from "./AccountNumberView.vue?vue&type=template&id=08fc1bd8"
import script from "./AccountNumberView.vue?vue&type=script&lang=js"
export * from "./AccountNumberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports